import { environment } from '~/util/environment';

/**
 * Link to the app details page in this portal.
 */
export function linkToApplicationDetails( applicationId: number ) {
  return `/appstation/${applicationId}`;
}

/**
 * Link to the station details page in this portal.
 *
 * If the stationEditV2Flag is enabled, this will link to the new station details page. Otherwise it
 * will link to the original version *in this portal*. It will never link to the legacy
 * ("developer") portal.
 */
export function linkToStationDetails( stationId: number ) {
  return `/stationV2/${stationId}`;
}

export function linkToFPQAStationDetails( stationId: number ) {
  return `/station/${stationId}`;
}

export function linkToDeveloperPortalApplicationDetails( applicationId: number ) {
  const { feedBaseEnvironment } = environment;
  const localOrStage = feedBaseEnvironment === 'local' || feedBaseEnvironment === 'stage';
  const subdomain = localOrStage ? `.${feedBaseEnvironment}` : '';
  return `//developer${subdomain}.feed.fm/application/${applicationId}`;
}

/**
 * Link to the station details page on the legacy portal.
 *
 */
export function linkToDeveloperPortalStationDetails( stationId: number ) {
  const { feedBaseEnvironment } = environment;
  const localOrStage = feedBaseEnvironment === 'local' || feedBaseEnvironment === 'stage';

  return `https://developer.${localOrStage ? `${feedBaseEnvironment}.` : ''}feed.fm/station/${stationId}`;
}
